/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LineHeightIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Line Height',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx="1" ry="1" width="22" x="12" y="4" />
    <rect height="4" rx="1" ry="1" width="22" x="12" y="16" />
    <rect height="4" rx="1" ry="1" width="22" x="12" y="28" />
    <path
      d="M9 30H6.994L7 8h2.006a.5.5 0 0 0 .5-.5.49.49 0 0 0-.147-.35L5.824 3.113a.5.5 0 0 0-.633 0L1.655 7.146a.491.491 0 0 0-.148.35.5.5 0 0 0 .5.5h2.008L4.009 30H2a.5.5 0 0 0-.5.5.49.49 0 0 0 .147.35l3.537 4.033a.5.5 0 0 0 .632 0l3.536-4.033a.491.491 0 0 0 .148-.35.5.5 0 0 0-.5-.5Z"
    />
  </svg>`;
};
